import { useCallback, FC } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Center, Flex, Icon, Text } from '@chakra-ui/react';
import icons from 'shared/icons';
import { dropZoneStyle, uploadedFileStyle } from 'shared/styles';
import { useTranslation } from 'helpers/languages/translations';

const MDropZone: FC<{ chosenFile: File | null; handleChangeFile: (file: File | null) => void }> = ({
    chosenFile,
    handleChangeFile,
}) => {
    const FilesIcon = icons.files;
    const ExcelIcon = icons.excel;
    const ClearIcon = icons.clear;

    const onDrop = useCallback((acceptedFiles: File[]) => {
        const productsFile = acceptedFiles[0];
        handleChangeFile(productsFile);
    }, []);

    // if we want to change the number of files to upload we change the maxFiles prop
    const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
        onDrop,
        maxFiles: 1,
        noClick: true,
    });
    const translate = useTranslation();

    return (
        <Box>
            <Center
                {...getRootProps({
                    ...dropZoneStyle,
                    border: isDragActive ? '1px solid #0F62FE' : '1px solid #bfb6b6',
                    ...(chosenFile
                        ? {
                              borderBottom: 'none',
                              borderBottomRadius: 0,
                          }
                        : {}),
                })}
            >
                <input {...getInputProps()} />
                <Center>
                    <Icon as={FilesIcon} w={8} h={8} color="gray.700" mr="16px" />
                    <Flex dir="row" alignItems="baseline">
                        <Text fontSize="18px" color="gray.500">
                            {translate('dropzone.description')}
                        </Text>
                        <Text
                            onClick={open}
                            cursor="pointer"
                            textDecor="underline"
                            ml="4px"
                            fontSize="18px"
                            color="blue.500"
                        >
                            {translate('dropzone.button')}
                        </Text>
                    </Flex>
                </Center>
            </Center>
            {chosenFile && (
                <Flex {...uploadedFileStyle}>
                    <Flex>
                        <Icon as={ExcelIcon} w={6} h={6} color="gray.700" />
                        <Text ml="12px">{chosenFile?.name}</Text>
                    </Flex>
                    <Center>
                        <Icon
                            cursor="pointer"
                            onClick={() => handleChangeFile(null)}
                            as={ClearIcon}
                            w={5}
                            h={5}
                            color="gray.700"
                        />
                    </Center>
                </Flex>
            )}
        </Box>
    );
};

export default MDropZone;
